import React from 'react'
import { AppFC } from 'types'

export const AppCard: AppFC = ({ children, className = '', onClick = () => {} }) => {
  return (
    <div onClick={onClick} className={`bg-white shadow-sm p-5 rounded-[20px] ${className}`}>
      {children}
    </div>
  )
}
